export enum AttendeeStatus {
    ACTIVE = 'ACTIVE',
    DEPARTED = 'DEPARTED',
    NOT_ACTIVE = 'NOT_ACTIVE',
    DISCONNECTING = 'DISCONNECTING',
    DISCONNECTED = 'DISCONNECTED',
}

export enum AttendeeConnectionVariant {
    RECONNECT = 'Reconnect',
    DISCONNECT = 'Disconnect'
}

export enum AttendeeSortFields {
    NAME = 'name',
    EMAIL = 'email',
    ARRIVAL = 'arrival',
    DEPARTURED = 'departured',
    DISCONNECTING = 'disconnecting',
    DISCONNECTED = 'disconnected',
}